import { PERMS } from '../../hooks/useAccess'

export const CAN_PULL_RESULT = {
  FULL: 'full',
  SESSION: 'session',
  NONE: ''
}

export const canPullTimeline = (hasPermission, convo, user) => {
  if (
    hasPermission(PERMS.ContactsAudit) &&
    hasPermission(PERMS.ConversationsFull)
  ) {
    return CAN_PULL_RESULT.FULL
  }

  if (hasPermission([PERMS.ConversationsBasic, PERMS.ConversationsActive])) {
    const { assigned_to } = convo
    if (user?.id === assigned_to) {
      return CAN_PULL_RESULT.SESSION
    }
  }

  return CAN_PULL_RESULT.NONE
}
